<template>
  <div
    v-if="totalFormCount > 0"
    class="d-flex flex-column ga-4"
  >
    <h2 class="d-flex justify-space-between">
      <span class="fs-24">{{ $bct('My forms') }}</span>

      <router-link
        :to="{ name: 'FamilyFormIndex' }"
        class="fs-16"
      >
        {{ $bct(`Show all ${totalFormCount} forms`) }}
      </router-link>
    </h2>

    <v-card
      v-for="form in forms"
      :key="form.id"
    >
      <v-card-title class="d-flex flex-column flex-sm-row py-2">
        <div class="fs-18">
          {{ $bct(form.name) }}
          <p>
            <LongDateTime
              :date="form.submitted_at || form.created_at"
              :prefix="form.submitted_at ? 'Submitted' : 'Created'"
              class="fs-14 font-weight-thin"
            />
          </p>
        </div>

        <v-spacer class="d-none d-sm-flex" />
        <v-btn
          @click="handleGoToForm(form)"
          :block="!$vuetify.display.smAndUp"
          :variant="form.submitted_at ? 'outlined' : undefined"
          class="my-2 align-self-start align-self-sm-center"
          color="primary"
        >
          {{ form.submitted_at ? $bct('View form') : $bct('Continue') }}
        </v-btn>
      </v-card-title>
    </v-card>
  </div>

  <FormReviewDialog ref="formReviewDialog" />
</template>

<script setup>
import { useRouter } from 'vue-router';

import FormReviewDialog from '@/shared/components/form/FormReviewDialog.vue';
import LongDateTime from '@/shared/components/LongDateTime.vue';
import useApi from '@/shared/composables/useApi';

const $bct = inject('translator');

const { api } = useApi();
const router = useRouter();

const forms = ref([]);
const formReviewDialog = ref(null);
const totalFormCount = ref(null);

async function load() {
  const response = await api.parent.form.dashboardSummary();
  forms.value = response.data.forms;
  totalFormCount.value = response.data.total_count;
}

async function handleGoToForm(form) {
  if (form.submitted_at) {
    formReviewDialog.value.open(form);
  } else {
    await router.push({
      name: 'FormContinue',
      params: {
        formId: form.id,
        schemaId: form.schema_id,
      },
      query: {
        backTo: 'Dashboard',
      },
    });
  }
}

onMounted(load);
</script>
